import { createActions, using } from "redux-box";

// export default {
//   requestpassage2list: (gradeId) => ({ type: "REQUEST_QUIZ2_LIST", gradeId }),
// };
export default createActions({
  //......................Reading CRUD..................
  setActivePassageGrade: using("grade"),
  requestPassage: using(),
  requestPassageListByGradeId: using("grade"),
  requestUpdatePassage: using("passage"),

  requestPassageById: using("passageId"),
  setPassageList: using("passageList"),
  setFetchPassageList: using("value"),
  setActivePassage: using("activePassage"),

  requestPassageByActiveGrade: using(),
  requestConcatPassages: using("offset"),
  setPassageLanguage: using("passageLanguage"),
});
